import React, { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import apiService from 'Service'
import uiStore from 'stores/uiStore'
import useFiscalAlertsHub from 'hooks/useFiscalAlertsHub'

const severityVariant = {
  Danger: 'danger',
  Warning: 'warning',
  Info: 'info'
}

const FiscalAlertsBanner = () => {
  const { t } = useTranslation()
  const [alerts, setAlerts] = useState([])

  const load = () => {
    apiService.FiscalCalendar.getCompanyAlerts()
      .then(data => setAlerts(Array.isArray(data) ? data : []))
      .catch(() => setAlerts([]))
  }

  useEffect(() => { load() }, [])

  useFiscalAlertsHub((alert) => {
    uiStore.notify({
      title: t('fiscal_alert') || 'Alerta fiscal',
      message: alert.Message,
      type: severityVariant[alert.Severity] || 'info',
      duration: 8000,
    })
    load()
  })

  if (!alerts.length) return null

  return (
    <div className="mb-2">
      {alerts.slice(0, 5).map(alert => (
        <Alert key={alert.EntryId} variant={severityVariant[alert.Severity] || 'info'} className="py-2 mb-1">
          <strong>{t('fiscal_alert') || 'Alerta fiscal'}:</strong> {alert.Message}
          {alert.DaysUntilDue === 0 && ` (${t('due_today') || 'vence hoy'})`}
        </Alert>
      ))}
    </div>
  )
}

export default FiscalAlertsBanner
